import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import '@fortawesome/fontawesome-free/css/all.min.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

// ========== 关键：设置 API 地址 ==========
// 判断当前是否开发环境
const isDev = process.env.NODE_ENV === 'development'

// 开发环境用本地，生产环境用 cpolar 地址
// TODO: 把 https://xxxxx.cpolar.cn 换成你的实际 cpolar 地址
const baseURL = isDev
  ? 'http://localhost:8080'
  : 'https://62975ba2.r29.cpolar.top'

axios.defaults.baseURL = baseURL
// ======================================

Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
